var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.878 84.6795C121.484 52.7465 106.072 44.2455 102.141 38.2362C100.519 35.589 99.0834 32.8373 97.8422 30C97.6345 32.8368 97.2529 34.624 94.7898 36.7752C89.8442 41.0919 68.8398 57.848 67.0722 94.1308C65.4252 127.96 92.4764 148.82 96.0503 150.976C98.7984 152.299 102.145 151.004 103.778 149.789C116.818 141.028 134.635 117.672 128.892 84.6795",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9625 132.962C98.2815 141.335 97.7937 146.2 96.0647 150.985C96.0647 150.985 97.1997 158.957 97.9966 167.401H100.817C101.49 161.454 102.517 155.552 103.894 149.723C100.242 147.964 99.1026 140.309 98.9625 132.962Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.889 149.727C100.199 148.058 99.1317 140.243 98.9675 132.962C99.88 120.951 100.146 108.902 99.7644 96.8635C99.5712 90.5469 99.8561 38.3591 98.1754 30.7186C99.3251 33.3064 100.65 35.8162 102.141 38.2314C106.072 44.2455 121.488 52.7464 128.878 84.6794C134.635 117.615 116.915 140.91 103.889 149.727Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongo);
export default __webpack_public_path__ + "static/media/mongo.bc2e5df499ac4d19a121ce37bde4b753.svg";
export { ForwardRef as ReactComponent };